export const article = document.querySelector('[data-article-listed]') as HTMLDivElement;

export const header = document.querySelector('header > .header-wrapper') as HTMLDivElement;

export const chapters: NodeListOf<HTMLDivElement> = article.querySelectorAll(
  '[data-article-listed-chapter]'
);

export const listedWrapper = document.querySelector(
  '[data-article-listed-wrapper]'
) as HTMLLIElement;

export const hasSelectElementPagination = document.querySelector(
  '[data-has-select-element-pagination]'
) as HTMLDivElement;

export const hasAllChaptersVisibleForLoggedIn = document.querySelector(
  '[data-has-all-chapters-visible-for-logged-in]'
) as HTMLDivElement;

export const navigations: NodeListOf<HTMLElement> = listedWrapper.querySelectorAll(
  '.article-listed-navigation'
);

export const btnIntro = document.querySelector('[data-article-listed-nav-intro]') as HTMLLIElement;

export const btnsPrev: NodeListOf<HTMLLIElement> = listedWrapper.querySelectorAll(
  '[data-article-listed-nav-prev]'
);

export const btnsNext: NodeListOf<HTMLLIElement> = listedWrapper.querySelectorAll(
  '[data-article-listed-nav-next]'
);

export const btnsLast: NodeListOf<HTMLLIElement> = listedWrapper.querySelectorAll(
  '[data-article-listed-nav-last]'
);

export const buttonsShowAll = listedWrapper.querySelectorAll(
  '[data-article-listed-show-all-article]'
);

export const cheapters = listedWrapper.querySelectorAll('.article-listed-chapter');

export const chapeterSelectors = listedWrapper.querySelectorAll('[data-article-listed-select]');

export const countersActiveChapter = listedWrapper.querySelectorAll('[data-active-chapter]');

export const dataChapterBoxWrappers = document.querySelectorAll('[data-chapter-box-wrapper]');

export const isUserLoggedIn = document.querySelector('[data-user-logged]') as HTMLLIElement;

export const hideThisWrappersOnLoggedIn = document.querySelectorAll('[data-hide-on-logged-in]');
